import { Button, LogoutButton } from '@components/Button';
import { Container } from '@components/Container';
import { StandardLayout } from '@components/Layouts/StandardLayout';
import { LoginModalUncontrolled } from '@components/LoginForm/LoginModal';
import { Paragraph } from '@components/Typography/Paragraph/Paragraph';
import { TextLink } from '@components/Typography/TextLink/TextLink';
import Head from 'next/head';
import type { ReactElement } from 'react';

export default function NoAccessPage(): ReactElement {
  return (
    <>
      <Head>
        <title>Access Denied to this page on the Bulk Website</title>
        <meta
          name="title"
          content="Access Denied to this page on the Bulk Website"
        />
        <meta
          name="description"
          content="Access to this page on the Bulk Nutrients website is denied. Please get in touch with our Customer Service team if you believe this is in error."
        />
        <meta name="robots" content="noindex" />
      </Head>
      {/** biome-ignore lint/correctness/useUniqueElementIds: we just the main-content with the skip to content button */}
      <Container
        as="main"
        id="main-content"
        className="grid-cols-[1fr_min(var(--width-narrow-page),calc(100%-16px))_1fr]"
      >
        <h1>You are not authorised to view this page</h1>
        <Paragraph>
          Please try{' '}
          <LogoutButton buttonStyle="text" className="inline">
            logging out
          </LogoutButton>{' '}
          then{' '}
          <LoginModalUncontrolled
            trigger={
              <Button buttonStyle="text" className="inline">
                log back in
              </Button>
            }
            title={<>Login to your account</>}
          />
          .
        </Paragraph>
        <Paragraph>
          If you still cannot view the page,{' '}
          <TextLink href="/contact-us">
            reach out to our Customer Service team
          </TextLink>
          .
        </Paragraph>
      </Container>
    </>
  );
}

NoAccessPage.getLayout = function getLayout(page: ReactElement) {
  return <StandardLayout>{page}</StandardLayout>;
};
